import {IPage, IVersionedId, ServiceBase} from '@/services/ServiceBase';
import * as request from 'superagent';

const API_URL = `${process.env.VUE_APP_API_URL}/atms`;

export class AtmsService extends ServiceBase {
    public static async getAtms(page: number, perPage: number): Promise<IPage<IAtm>> {
        try {
            const result = await (this.authRequest(request
                .get(API_URL)))
                .query(`page=${page}`)
                .query(`perPage=${perPage}`)
                .timeout(10000);
            return result.body;
        } catch (err) {
            console.error('Error while fetching atms!', err);
            throw err;
        }
    }

    public static async getAtm(id: number): Promise<IAtm> {
        try {
            const result = await (this.authRequest(request
                .get(`${API_URL}/${id}`)
                .timeout(10000)));

            return result.body;
        } catch (err) {
            console.error(`Error while fetching a single atm with id ${id}`, err);
            throw err;
        }
    }

    public static async createAtm(atm: IInsertableAtm): Promise<IVersionedId> {
        try {
            const result = await (this.authRequest(request
                .post(API_URL)))
                .send(atm)
                .timeout(5000);

            return result.body;
        } catch (err) {
            console.error('Error while creating atm!', err);
            throw err;
        }
    }

    public static async updateAtm(id: number, version: number, atm: IUpdatableAtm): Promise<IVersionedId> {
        try {
            const result = await (this.authRequest(request
                .patch(`${API_URL}/${id}`)
                .send({
                    id,
                    version,
                    data: atm,
                })
                .timeout(5000)));

            return result.body;
        } catch (err) {
            console.error('Error while updating atm!', err);
            throw err;
        }
    }

    public static async deleteAtm(id: number): Promise<void> {
        try {
            await (this.authRequest(request
                .delete(`${API_URL}/${id}`)))
                .timeout(5000);
        } catch (err) {
            console.error('Error while deleting atm!', err);
            throw err;
        }
    }
}

export interface IAtm {
    id: number;
    address: string;
    town: string;
    location_name: string;
    sm_id: string;
    type: string;
    model: string;
    sn_id: string;
    year: string;
    ws_id: string;
    t_id_b24: string;
    v_p: string;
    admin_room: string;
    upn: string;
    ap: string;
    qr: string;
    cl: string;
    dep: string;
    vnc: string;
    intranet: string;
    anti_skimming: string;
    storey: string;
    board: string;
    jurisdiction: string;
    regime: string;
    third_key: string;
    version: number;
}

export interface IInsertableAtm {
    address: string;
    town: string;
    location_name: string;
    sm_id: string;
    type: string;
    model: string;
    sn_id: string;
    year: string;
    ws_id: string;
    t_id_b24: string;
    v_p: string;
    admin_room: string;
    upn: string;
    ap: string;
    qr: string;
    cl: string;
    dep: string;
    vnc: string;
    intranet: string;
    anti_skimming: string;
    storey: string;
    board: string;
    jurisdiction: string;
    regime: string;
    third_key: string;
}

export interface IUpdatableAtm {
    address: string;
    town: string;
    location_name: string;
    sm_id: string;
    type: string;
    model: string;
    sn_id: string;
    year: string;
    ws_id: string;
    t_id_b24: string;
    v_p: string;
    admin_room: string;
    upn: string;
    ap: string;
    qr: string;
    cl: string;
    dep: string;
    vnc: string;
    intranet: string;
    anti_skimming: string;
    storey: string;
    board: string;
    jurisdiction: string;
    regime: string;
    third_key: string;
}